// only trigger on homepage
if (document.querySelector('.page-home')) {
    let noodleTriggered = false;
    const video = document.querySelector(
        '.hero-video__container--desktop .hero-video__video'
    );
    const heroSection = document.querySelector('.hero__section');
    if (video) {
        video.ontimeupdate = (e) => {
            if (e.timeStamp > 3800 && !noodleTriggered) {
                noodleTriggered = true;
                heroSection.classList.add('hero__section--noodle-visible');
            }
        };
    }
}
